var map = {
	"./en": 2152,
	"./en/": 2152,
	"./en/index": 2152,
	"./en/index.json": 2152,
	"./hi": 488,
	"./hi/": 488,
	"./hi/index": 488,
	"./hi/index.json": 488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;